var player;
var langMsgAdded="Na Twój adres email wysłany został link aktywacyjny";

if($(".video-wrapper").length>0) {
    function onYouTubeIframeAPIReady() {
        player = new YT.Player('main-player', {
            events: {
                onReady: onPlayerReady,
                onStateChange: onPlayerStateChange
            }
        });

    }
    function onPlayerReady(event) {
        //player.mute();
        //player.setVolume(0);
    }
    function onPlayerStateChange(event) {

        if (event.data === 0) {
            $(".start-video").css('display', 'block');
            $(".video-wrapper").addClass('inactive');
        } else {
            $(".start-video").css('display', 'none');
        }
    }
}
$(document).ready(function(){
    $(".start-video").on('click',function(){
        player.playVideo();
        $(".video-content").fadeIn(0);
        $(".video-wrapper").removeClass('inactive');
    });
    console.log('Hello World!');

    var slider = $('.bxslider').bxSlider({
        mode: 'fade',
        auto: true,
        pause: 4400,
        speed: 800,
        autoControls: false,
        autoStart: true,
        pager: false,
        onSliderLoad: function () {
            setTimeout(function () {
                $('.bxslider #firstSlide').addClass('active');
            }, 600);

        },
        onSlideAfter: function (el,oI,nI) {
            $('.bxslider li').removeClass('active');
            el.addClass('active');
            slider.startAuto();
        }

});

    // Komunikat o ciasteczkach
    var cookieInfoLayer = $('#cookie-info-layer');
    if(cookieInfoLayer.length){
        var showCookieInfoLayer = function() {
            if($.cookie('cookie_info') != 'set'){
                cookieInfoLayer.delay(1000).fadeIn(1000);
            }
        };


        showCookieInfoLayer();
        cookieInfoLayer.find('.cookie-info-close').on('click',function(){
            $.cookie('cookie_info', 'set', { expires: 365, path: '/' });
            cookieInfoLayer.fadeOut(500);
        });
    }

    // Walidacja formularza
    $("#contact-form").validate({
        rules: {
            email: {
                required: true,
                email: true
            },
            name: {
                required: true,
                minlength: 2
            },
            subject: {
                required: true,
                minlength: 2
            },
            message: {
                required: true,
                minlength: 10
            }
        },
        messages: {
            email: {
                required: 'Pole wymagane',
                email: 'Wpisz poprawny adres email'
            },
            name: {
                required: 'Pole wymagane',
                minlength: 'Wpisz conajmniej {0} znaki'
            },
            subject: {
                required: 'Pole wymagane',
                minlength: 'Wpisz conajmniej {0} znaki'
            },
            message: {
                required: 'Pole wymagane',
                minlength: 'Wpisz conajmniej {0} znaków'
            }
        }
    });
    $('#raportForm #add').on('click', function(){

/*        if($(this).data('type') == 'remove'){
            $('#agree1').rules('remove');
            $('#agree2').rules('remove');
        } else {
            $('#agree1').rules('add', {required: true});
            $('#agree2').rules('add', {required: true});
        }*/
        //$(this).parents('form').attr('action',$(this).data('action')).submit();

    });

    var raportValid = $('#raportForm').validate({
        rules: {
            name: {
                required: true,
                minlength: 6
            },
            email: {
                email: true,
                required: true
            },
            agree1: {
                required: true
            },
            agree2: {
                required: true
            },
            gender: {
                required: true
            }
        },
        messages: {
                email: {
                    required: 'Pole wymagane',
                    email: 'Wpisz poprawny adres email'
                },
                name: {
                    required: 'Pole wymagane',
                    minlength: 'Wpisz conajmniej {0} znaków'
                },
                agree1: {
                    required: 'Pole wymagane'
                },

                agree2: {
                    required: 'Pole wymagane'
                },
                gender: {
                    required: 'Pole wymagane'
                }

        },
        submitHandler: function(form) {
            var postUrl = $(form).attr('action');
            var name = $(form).find('input#name').val();
            var email = $(form).find('input#email').val();
            var agree1 = $(form).find('input#agree1').val();
            var agree2 = $(form).find('input#agree2').val();
            var gender = $(form).find('input[name="gender"]:checked').val();
            $.post(postUrl, { name: name, email: email, agree1: agree1, agree2: agree2, gender: gender }, function(data){
                var show = true;
                var container = $('#raportFormContainer');
                var info;
                data = $.parseJSON(data);
                console.log(data);
                switch(data.status){
                    case "ADDED":
                        info = langMsgAdded;
                        break;
                    case "NO_VALID":
                        info = langMsgAdded;
                        show = false;
                        break;
                    case 'EXISTS':
                        $('#email-error').text("Podany email istnieje w bazie");
                        $('#email-error').show();
                        var errors = { email: "Podany email istnieje w bazie" };
                        raportValid.showErrors(errors);
                        show = false;
                        break;
                    default:
                        show = false;
                }

                if(show) {
                    container.find('#add').hide();
                    container.find('.info').html(info).show();
                }

                //loader(false);
            });
            return false;
        }
    });

    var didScroll;
    var highMenu = 1;
// on scroll, let the interval function know the user has scrolled
    $(window).scroll(function(event){
        didScroll = true;
    });
// run hasScrolled() and reset didScroll status
    setInterval(function() {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 100);
    function hasScrolled() {
        var scroll = $(window).scrollTop();
        if(scroll>300){
            if(highMenu==1){
            $("#header").removeClass("high-menu");
            $("#header").addClass("low-menu");
            highMenu=0;
            }
        }
        else{
            if(highMenu==0){

            $(".logo").fadeOut(0);
            $("#header").removeClass("low-menu");
            $("#header").addClass("high-menu");
            highMenu=1;
               setTimeout(function(){$(".logo").fadeIn(50);},150);
            }
        }
    }

    $('#nav-mobile').click(function(){
        $(this).toggleClass('open');
        if($(this).hasClass('open')){
            $(".navigation").css('display','block');
        }
        else{
            $(".navigation").css('display','none');
        }
    });

    $(".down-arrow").on("click",function(){
        $('html, body').animate({
            scrollTop: ($(".main-content").offset().top - 100)
        }, 500);
    });
});